import { FC } from 'react';
import cn from 'classnames';

import { DataButton } from 'components/Shared/SharedComponents';
import { capitalizeFirstLetter } from 'lib/text.service';
import { IS_CLIENT_SIDE } from 'constants/constants';

import styles from './CardsViewButton.module.scss';
import type { ICardsViewButton } from './declarations';

const CardsViewButton: FC<ICardsViewButton> = ({ isSelected, shape, ...rest }) => {
  /** This was added due to wrong rendering. If it will work bad
   * we can detect a cookie on the level above and render based on it
   */
  if (!IS_CLIENT_SIDE) {
    return null;
  }

  return (
    <DataButton
      className={cn(styles.icon, styles[`icon${capitalizeFirstLetter(shape)}`])}
      {...rest}
    >
      {new Array((shape === 'square') ? 1 : 2).fill(0).map((_, i) => (
        <i
          key={i.toString()}
          className={cn(
            styles[shape],
            {
              [styles.colorActive]: isSelected,
              [styles.colorInactive]: !isSelected,
            },
          )}
        />
      ))}
    </DataButton>
  );
};

export default CardsViewButton;
